<template>
  <el-dialog
    title="查看收车信息"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="900px"
    class="BoxRight"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      status-icon
      ref="form"
      label-position="right"
      label-width="100px"
    >
      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">车主信息</div>
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="车主姓名">
            <div class="text">{{ form.OwnerName | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话">
            <div class="text">{{ form.ContactNumber | gang }}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">收款人信息</div>
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否代办" prop="IsProve">
            <div class="text">
              {{
                form.IsProve == "0" ? "否" : form.IsProve == "1" ? "是" : "-"
              }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收款人姓名" prop="BankUsername">
            <div class="text">{{ form.BankUsername | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="银行卡号" prop="BankNo">
            <div class="text">{{ form.BankNo | gang }}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-show="this.form.IsProve == '1' ? true : false">
        <div class="FromTitleStyle">
          <div class="FromTitleBorder"></div>
          <div class="FromTitleText">委托人信息</div>
        </div>
        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名">
              <div class="text">{{ form.ClientUser | gang }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话">
              <div class="text">{{ form.ClientTel | gang }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身份证号">
              <div class="text">{{ form.ClientCardNumber | gang }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="委托书">
              <div class="demo-image__preview">
                <el-image
                  style="width: 130px; height: 130px"
                  :src="form.ClientProveUrlUrl"
                  :preview-src-list="[form.ClientProveUrlUrl]"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身份证正面">
              <div class="demo-image__preview">
                <el-image
                  style="width: 130px; height: 130px"
                  :src="form.ClientFontUrlUrl"
                  :preview-src-list="[form.ClientFontUrlUrl]"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身份证反面">
              <div class="demo-image__preview">
                <el-image
                  style="width: 130px; height: 130px"
                  :src="form.ClientBackUrlUrl"
                  :preview-src-list="[form.ClientBackUrlUrl]"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="FromTitleStyle">
        <div class="FromTitleBorder"></div>
        <div class="FromTitleText">车辆信息</div>
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="车牌号">
            <div class="text">{{ form.LicensePlate | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车架号后6位">
            <div class="text">{{ form.VinSix | gang }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收车日期">
            <div class="text">
              {{ form.RegistrationDate | datetime("YYYY-MM-DD") }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="整车照">
            <div class="demo-image__preview">
              <el-image
                style="width: 130px; height: 130px"
                :src="[form.VehiclePhotoUrl]"
                :preview-src-list="[form.VehiclePhotoUrl]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="电池缺失证明">
            <div class="demo-image__preview">
              <el-image
                style="width: 130px; height: 130px"
                :src="form.BatteryMissingProofUrl"
                :preview-src-list="[form.BatteryMissingProofUrl]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
    
<script>
export default {
  props: ["item"],
  components: {},
  data() {
    return {
      visible: false,
      form: {},
    };
  },
  computed: {},
  watch: {
    item: {
      handler: function (v) {
        this.visible = true;
        this.$get("VehicleRegistration/GetItem", {
          KeyId: v.KeyId,
        }).then((r) => {
          this.form = { ...r.Result };
        });
      },
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
  margin-top: 10px;
  @include font_color("text-color2");
}
</style>